<script setup lang="ts">
defineOptions({
  name: 'ConfiguratorLayout'
})
</script>

<template>
  <div class="configurator-layout">
    <!-- Header avec titre -->
      <slot name="header"></slot>

    <!-- Grande zone de visualisation -->
    <div class="layout-viewer">
      <slot name="viewer"></slot>
    </div>

    <!-- Barre de contrôle (boutons intérieur/extérieur + prix) -->
    <div class="layout-controls">
      <slot name="controls"></slot>
    </div>

    <!-- Section configuration (tabs + contenu) -->
    <div class="layout-configuration">
      <slot name="configuration"></slot>
    </div>
  </div>
</template>

<style scoped>
.configurator-layout {
  display: grid;
  grid-template-areas:
    "header"
    "viewer"
    "controls"
    "configuration";
  grid-template-rows: auto auto auto 1fr;
  grid-template-columns: 1fr;
  min-height: 100vh;
  background: var(--color-bg-body);
  gap: 0;
}

.layout-viewer {
  grid-area: viewer;
}

.layout-controls {
  grid-area: controls;
}

.layout-configuration {
  grid-area: configuration;
  min-width: 0; /* Empêche le contenu grid de dépasser */
  overflow: hidden;
}
</style>